/* eslint-disable tsdoc/syntax */

import { SVGProps } from "react";
export const NoSales = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 100 85"
    width="1em"
    height="1em"
    fill="none"
    preserveAspectRatio="xMidYMid meet"
    {...props}
  >
    <path
      stroke="#DDE1E5"
      strokeWidth={1.21}
      d="M2.663 58.225c1.155 0 2.058.901 2.058 1.971s-.903 1.972-2.058 1.972c-1.155 0-2.059-.901-2.059-1.972 0-1.07.904-1.971 2.06-1.971Z"
    />
    <path
      stroke="#EC948D"
      strokeWidth={1.613}
      d="M34.328.807c1.418 0 2.523 1.105 2.523 2.414 0 1.308-1.105 2.414-2.523 2.414-1.418 0-2.521-1.106-2.521-2.414 0-1.309 1.103-2.414 2.521-2.414Z"
    />
    <g stroke="#EC948D" strokeLinecap="round" strokeWidth={1.21}>
      <path d="M88.997 50v3.865M90.994 51.932H87" />
    </g>
    <g stroke="#EC948D" strokeLinecap="round" strokeWidth={2.016}>
      <path d="M6.328 21v6.441M9.657 24.22H3" />
    </g>
    <path
      stroke="#DDE1E5"
      strokeWidth={1.21}
      d="M82.663 16.605c1.155 0 2.058.901 2.058 1.971s-.903 1.972-2.058 1.972c-1.155 0-2.058-.902-2.058-1.972 0-1.07.903-1.971 2.058-1.971Z"
    />
    <path
      fill="#DDE1E5"
      d="m72.672 27.639 1.678 57.504a6.168 6.168 0 0 1-5.985 6.345l-38.97 1.137a6.168 6.168 0 0 1-6.345-5.986l-1.677-57.504L32.8 16.112l28.026-.818L72.672 27.64Zm-29.264-1.253a5.368 5.368 0 1 0 .313 10.732 5.368 5.368 0 0 0-.313-10.732Z"
    />
    <path
      fill="#F6F7F7"
      d="M59.117 11.234a4 4 0 0 1 3.143.802l10.557 8.317a4 4 0 0 1 1.468 2.473l9.328 55.05a5 5 0 0 1-4.094 5.765l-39.693 6.726a5 5 0 0 1-5.765-4.094l-9.323-55.018a4 4 0 0 1 .602-2.866l7.499-11.408a4 4 0 0 1 2.674-1.747l23.604-4Zm-13.642 12.82A5.257 5.257 0 1 0 47.23 34.42a5.257 5.257 0 0 0-1.755-10.366Z"
    />
    <path
      fill="#919C9F"
      d="M45.317 3.918c3.531-1.695 7.608-1.087 10.89 2.194 1.741 1.742 2.655 4.594 2.914 7.603.262 3.043-.128 6.427-1.178 9.402-1.044 2.96-2.787 5.637-5.323 7.083-2.515 1.434-5.63 1.556-9.219-.136l-.348-.17-.09-.05a1 1 0 0 1 .89-1.78l.094.041.304.148c3.116 1.471 5.534 1.26 7.379.209 1.963-1.12 3.47-3.3 4.427-6.01.95-2.695 1.31-5.794 1.072-8.566-.241-2.806-1.078-5.101-2.336-6.36-2.718-2.718-5.891-3.11-8.61-1.805-2.647 1.27-5.018 4.231-6.06 8.644l-2.114.325.01-.068c1.046-5.225 3.822-9.035 7.298-10.704Z"
    />
  </svg>
);
